import {milesoft} from "@atttomyx/shared-constants";

export const openTermsOfService = () => window.open(milesoft.COMPANY_WEBSITE + "/user-terms-of-service", "legal");

export const openAcceptableUsePolicy = () => window.open(milesoft.COMPANY_WEBSITE + "/acceptable-use-policy", "legal");

export const openPrivacyPolicy = () => window.open(milesoft.COMPANY_WEBSITE + "/privacy-policy", "legal");
